/** Sort events newest-first by game clock (minute*60 + second). Returns a copy. */
export function sortByEventTime<T extends { minute: number; second: number }>(
  events: readonly T[],
): T[] {
  return events
    .slice()
    .sort((a, b) => b.minute * 60 + b.second - (a.minute * 60 + a.second));
}
